export default __webpack_public_path__ + "static/media/mail_opened.9fede8db.png";